"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageType = exports.isStorageAvailable = exports.BrowserStorageItem = void 0;
var StorageType;
(function (StorageType) {
    StorageType["SESSION_STORAGE"] = "session";
    StorageType["LOCAL_STORAGE"] = "local";
})(StorageType || (StorageType = {}));
exports.StorageType = StorageType;
var isStorageAvailable = function (storageType) {
    var storageTest = 'test';
    try {
        var storage = storageType === StorageType.SESSION_STORAGE
            ? window.sessionStorage
            : window.localStorage;
        storage.setItem(storageTest, storageTest);
        storage.removeItem(storageTest);
        return true;
    }
    catch (_a) {
        return false;
    }
};
exports.isStorageAvailable = isStorageAvailable;
var getStorage = function (type) {
    if (typeof window !== 'undefined') {
        if (type === StorageType.LOCAL_STORAGE && isStorageAvailable(StorageType.LOCAL_STORAGE)) {
            return window.localStorage;
        }
        return isStorageAvailable(StorageType.SESSION_STORAGE) ? window.sessionStorage : undefined;
    }
    return undefined;
};
var BrowserStorageItem = (function () {
    function BrowserStorageItem(key, storageType) {
        this.key = key;
        this.storage = getStorage(storageType);
    }
    BrowserStorageItem.prototype.get = function () {
        if (!this.storage) {
            return null;
        }
        try {
            return this.storage.getItem(this.key);
        }
        catch (_a) {
            return null;
        }
    };
    BrowserStorageItem.prototype.set = function (value) {
        var _a;
        (_a = this.storage) === null || _a === void 0 ? void 0 : _a.setItem(this.key, value);
    };
    BrowserStorageItem.prototype.remove = function () {
        var _a;
        (_a = this.storage) === null || _a === void 0 ? void 0 : _a.removeItem(this.key);
    };
    return BrowserStorageItem;
}());
exports.BrowserStorageItem = BrowserStorageItem;
//# sourceMappingURL=browser-storage-item.js.map